import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getCurrentWorkOrder,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import { getChangeOrderTasks } from 'components/admin/work-orders/details/change-order-tasks/store/selectors';
import { getSelectedChangeOrderTaskId } from 'components/admin/work-orders/details/change-order-quotes/store/selectors';
import {
  closeChangeOrderQuoteDetailsModal,
  updateChangeOrderQuote,
} from 'components/admin/work-orders/details/change-order-quotes/store/actions';
import ChangeOrderQuoteDetailsModal from 'components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteDetailsModal';

class ChangeOrderQuoteDetailsModalContainer extends Component {
  handleClose = () => {
    this.props.dispatch(closeChangeOrderQuoteDetailsModal());
  };

  handleSave = (values) => {
    const {
      changeOrderTasks,
      selectedChangeOrderTaskId,
      dispatch,
    } = this.props;
    const changeOrderTask = changeOrderTasks.find(
      (element) => element.id === selectedChangeOrderTaskId
    );
    dispatch(updateChangeOrderQuote(changeOrderTask.id, values));
  };

  render() {
    const changeOrderTask = this.props.changeOrderTasks.find(
      (element) => element.id === this.props.selectedChangeOrderTaskId
    );
    let task;

    if (changeOrderTask) {
      task = this.props.tasks.find(
        (element) => element.id === changeOrderTask.task_id
      );
    }

    return (
      !!changeOrderTask && (
        <ChangeOrderQuoteDetailsModal
          show={!!changeOrderTask}
          changeOrderTask={changeOrderTask}
          task={task}
          workOrder={this.props.currentWorkOrder}
          onClose={this.handleClose}
          onSave={this.handleSave}
        />
      )
    );
  }
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    tasks: getTasks(state),
    changeOrderTasks: getChangeOrderTasks(state),
    selectedChangeOrderTaskId: getSelectedChangeOrderTaskId(state),
  };
})(ChangeOrderQuoteDetailsModalContainer);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteDetailsModalContainer.js